export default {
  defaultTitle: {
    en: 'Order by Dec. 11 to get your holiday gifts in time',
  },
  title: {
    en: '{discount}% off select products',
  },
  button: {
    en: 'Shop now',
  },
}
